import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import apiService from '@/services/api.service';
import { logger } from '@/utils/logger';
import { ForgotPasswordContainer, StyledCard } from './styles/ForgotPassword.styles';

const { Title, Text } = Typography;

const ForgotPassword: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (values: { email: string }) => {
        try {
            setLoading(true);
            await apiService.post('/auth/forgot-password', { email: values.email });
            setSubmitted(true);
            message.success('Если указанный email существует, на него отправлена ссылка для восстановления пароля');
        } catch (error: any) {
            logger.error('Error requesting password reset:', error);
            message.error(error.response?.data?.message || 'Не удалось отправить запрос на восстановление пароля');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <ForgotPasswordContainer>
                <StyledCard>
                    <div style={{ textAlign: 'center' }}>
                        <MailOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                        <Title level={3}>Проверьте почту</Title>
                        <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
                            Если указанный email существует в системе, на него отправлена ссылка для восстановления пароля.
                            Пожалуйста, проверьте почту и следуйте инструкциям в письме.
                        </Text>
                        <Button type="link" onClick={() => navigate('/login')}>
                            <ArrowLeftOutlined /> Вернуться к входу
                        </Button>
                    </div>
                </StyledCard>
            </ForgotPasswordContainer>
        );
    }

    return (
        <ForgotPasswordContainer>
            <StyledCard>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                    <Title level={2}>Восстановление пароля</Title>
                    <Text type="secondary">
                        Введите email, указанный при регистрации, и мы отправим вам ссылку для восстановления пароля
                    </Text>
                </div>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    size="large"
                >
                    <Form.Item
                        name="email"
                        rules={[
                            { required: true, message: 'Введите email' },
                            { type: 'email', message: 'Некорректный email' }
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder="Email"
                            autoComplete="email"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            loading={loading}
                        >
                            Отправить ссылку
                        </Button>
                    </Form.Item>

                    <div style={{ textAlign: 'center', marginTop: 16 }}>
                        <Link to="/login">
                            <ArrowLeftOutlined /> Вернуться к входу
                        </Link>
                    </div>
                </Form>
            </StyledCard>
        </ForgotPasswordContainer>
    );
};

export default ForgotPassword;

